import { ArchiveOutlineIcon } from './ArchiveOutlineIcon';

/**
 * author: James Coyle
 * id 4B8AAB0C-9EB8-44D9-B1DF-C2EE6ACB91BE
 * name archive-outline
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-outline.svg
 * tags
 */
export const BoxOutlineIcon = ArchiveOutlineIcon;
export default BoxOutlineIcon